<template>
  <input 
    type="text" 
    v-datepicker 
    class="datepicker form-control" 
    :value="value" 
    @input="update($event.target.value)"
  >
</template>

<script>
export default {
  directives: {
    datepicker: {
      inserted(el, binding, vNode) {
        $(el)
          .datepicker({
            autoclose: true,
            format: "yyyy-mm-dd",
          })
          .on("changeDate", function (e) {
            vNode.context.$emit("input", e.format(0));
          });
      },
    },
  },
  props: ["value"],
  methods: {
    update(v) {
      this.$emit("input", v);
    },
  },
}
</script>